module.exports = __webpack_public_path__ + "img/JT_icons01_64px_Follow.d64ccdc3.svg";